import { NumberInput as MNumberInput } from '@mantine/core';
import classes from './numberInput.module.scss';

export const NumberInput = MNumberInput.extend({
  defaultProps: {
    classNames: classes,
    hideControls: true,
    max: Number.MAX_SAFE_INTEGER,
  },
});
